import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/compass-flat/compass-flat.js';
      import {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
import {CompassFlatPriorityElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/compass-flat/compass-flat.js';
import {RotType} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/rate-of-turn/rot-renderer.js';

      export interface Props {
     FOVIndicator?: boolean;
     heading?: number;
     courseOverGround?: number;
     tickInterval?: number;
     FOV?: number;
     minFOV?: number;
     maxFOV?: number;
     priority?: Priority;
     priorityElements?: CompassFlatPriorityElement[];
     rotType?: RotType | undefined;
     rotationsPerMinute?: number;
     rotMaxValue?: number;
     rotArcExtent?: number;
     rotPortStarboard?: boolean;
     rotAtZeroDeadband?: number
   }

      
  
      export type {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
export type {CompassFlatPriorityElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/compass-flat/compass-flat.js';
export type {RotType} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/rate-of-turn/rot-renderer.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcCompassFlat',
  props: {
    FOVIndicator: { type: Boolean },
    heading: {},
    courseOverGround: {},
    tickInterval: {},
    FOV: {},
    minFOV: {},
    maxFOV: {},
    priority: {},
    priorityElements: {},
    rotType: {},
    rotationsPerMinute: {},
    rotMaxValue: {},
    rotArcExtent: {},
    rotPortStarboard: { type: Boolean },
    rotAtZeroDeadband: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-compass-flat',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})